import {Component, OnInit, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {FilterService} from '../../../services/filter.service';
import {UserPreferenceService} from '../../../services/user-preference.service';

@Component({
  selector: 'app-caregiver-performance-grid-empty-state',
  templateUrl: './caregiver-performance-grid-empty-state.component.html',
  styleUrls: ['./caregiver-performance-grid-empty-state.component.scss'],
  standalone: true,
  imports: [MatButtonModule],
})
export class CaregiverPerformanceGridEmptyStateComponent implements OnInit {
  private filterService = inject(FilterService);
  private userPreferenceService = inject(UserPreferenceService);

  isActiveSearch: boolean = false;
  isActiveFilter: boolean = false;
  hasColumnsSelected: boolean = true;
  ngOnInit(): void {
    this.setIsActiveSearch();
    this.setIsActiveFilter();
    this.filterService.currentSelectionsChange$.subscribe(() => {
      this.setIsActiveSearch();
      this.setIsActiveFilter();
    });

    this.userPreferenceService.userPreferences$.subscribe((userPreference) => {
      this.hasColumnsSelected =
        userPreference.caregiverDashboardColumns.filter(
          (cdc) => !cdc.hideColumn
        ).length > 0;
    });
  }

  clearFiltersAndSearch() {
    this.filterService.clearAllFilters();
  }

  private setIsActiveSearch(): void {
    const searchCurrentSelection = this.filterService.currentSelections
      .caregiverSearch;
    if (!searchCurrentSelection) {
      this.isActiveSearch = false;
      return;
    }
    const currentSearchValue = searchCurrentSelection.filterValue;
    this.isActiveSearch = currentSearchValue && currentSearchValue !== '';
  }

  private setIsActiveFilter(): void {
    this.isActiveFilter =
      this.filterService.currentSelectionsAsChipDisplay.length > 0;
  }
}
